<template>
    <div>
        <span>Loading...</span>
    </div>
</template>

<script>
    import Auth from '../services/Auth';

    export default {
        'props': {
            code: {
                type: String,
                default: undefined,
            },
            index: false,
        },
        'data': function ()  {
            return {
            }
        },
        'methods': {
            onMessage: function(data) {
                console.log(data);
            }
        },
        mounted() {
            this.$router.replace({name: 'assignment', params: {code: this.code, index: this.index}})
        }
    }
</script>